import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BroadcastHistory from "../../../../AppComponents/Forms/AppMarketingListDetails";
import { useNotification } from "../../../../Hooks/useNotification/useNotification";
import { useAppDispatch } from "../../../../Store";
import { broadcastActions } from "../../../../Store/Slices/BroadcastDashboard/BroadcastDash.actions";
import { AppToolTip } from "../../../UiComponents/AppToolTip/AppToolTip";
import { LeftCol, RightCol, TopBar, WrapperContainer } from "./HistoryStyles";
const WhatsappBroadcastHistory = () => {
  const dispatch = useAppDispatch();
  const broadcast_id = useParams();
  const [errorApi, setErrorApi] = useState(false);
  const [statsData, setStatsData] = useState<any>([]);
  const [credits, setCredits] = useState<any>([]);
  const [data, setData] = useState<any>([]);
  const header = ["Name", "Mobile No", "Status"];
  let { showAlert } = useNotification();
  const getStatsData = () => {
    dispatch(
      broadcastActions.getBroadcastStatsData(broadcast_id?.broadcast_id)
    )
      .then((res: any) => {
        setStatsData(res?.payload?.data?.broadcast_stats);
      })
      .catch((error: any) => {
        setErrorApi(true);
        showAlert(
          error?.response?.statusText || "Unable to fetch data",
          "error"
        );
      })
      .finally(() => {});
  };
  useEffect(() => {
    // Fetch the file URL from the backend
    getStatsData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const getCreditsData = (data: any) => {
    setCredits(data);
  };
  // Data For Analytics
  useEffect(() => {
    setData([
      {
        id: 1,
        left: {
          name: "Sent",
          tooltiptext: "Total number of messages sent from all broadcasts.",
          icon: "Send",
          count: statsData?.sent,
          bgColor: "#098906",
        },
        right: {
          name: "Delivered",
          tooltiptext:
            "Total number of messages successfully delivered to the recipients from all broadcasts.",
          icon: "DoneAllOutlined",
          count: statsData?.delivered,
          bgColor: "#098906",
        },
      },
      {
        id: 2,
        left: {
          name: "Seen",
          tooltiptext:
            "Total number of messages seen by the recipients from all broadcasts.",
          icon: "RemoveRedEyeOutlined",
          count: statsData?.seen,
          bgColor: "#3654E3",
        },
        middle: {
          name: "Replied",
          tooltiptext:
            "Total number of contacts who replied to broadcast message.",
          icon: "ReplyOutlined",
          count: statsData?.replied,
          bgColor: "#3654E3",
        },
        right: {
          name: "Failed",
          tooltiptext:
            "Total number of messages that have failed to be delivered to the recipients.",
          icon: "Close",
          count: statsData?.failed,
          bgColor: "#E33636",
        },
      },
      {
        id: 3,
        left: {
          name: "Queued",
          tooltiptext: "Total number of messages are in queued to be sent.",
          icon: "FormatListBulletedOutlined",
          count: statsData?.queued,
          bgColor: "#FFBE3F",
        },
        right: {
          name: "Processing",
          tooltiptext: "Total number of messages that are being sent now.",
          icon: "CachedOutlined",
          count: statsData?.processing,
          bgColor: "#FFBE3F",
        },
      },
    ]);
  }, [statsData]);
  return (
    <WrapperContainer>
      <TopBar>
        <LeftCol>
          <label>To know your Messaging Limit please</label>
          <Box className="limit">
            <a
              href="https://developers.facebook.com/docs/whatsapp/messaging-limits/"
              target="_blank"
              rel="noreferrer"
            >
              Click here
            </a>
          </Box>
        </LeftCol>
        <RightCol>
          <Box className="contact">
            <label>
              <span className="contact-label">Connected WA No.:</span>
              <strong> {credits?.whatsapp_no}</strong>
            </label>
          </Box>
          <Box>
            <Box className="monthly-conversations__wrapper" >
              <Box className="conversations">
                <Box className="monthly-conversations">
                  <AppToolTip
                    tooltipProps={{
                      title: `Each WhatsApp Business Account gets 1,000 free service conversations (user-initiated conversations) each month across all of its business phone numbers. This number is refreshed at the beginning of each month, based on WhatsApp Business Account time zone. Marketing, utility and authentication conversations are not part of the free tier`,
                      placement: "right",
                    }}
                    iconButtonProps={{ disableRipple: true }}
                    IconComponent={<InfoOutlinedIcon />}
                  />
                  <div className="conversations-label">
                    Free Monthly conversations:<strong> {credits?.free_conversation || 0}</strong>
                  </div>
                
              </Box>
              </Box>
            </Box>
            <Box className="credits">
              <Box>
                <label>
                  Balance credits:{" "}
                  <strong>{credits?.remaining_amount || 0}</strong>
                </label>
              </Box>
            </Box>
          </Box>
        </RightCol>
      </TopBar>
      <BroadcastHistory
        height="612px"
        headerTitle="Whatsapp Broadcast Analytics"
        data={data}
        header={header}
        getCreditsData={getCreditsData}
      />
    </WrapperContainer>
  );
};

// Default Export of component
export default WhatsappBroadcastHistory;
